module.exports = __webpack_public_path__ + "img/news3.065a4ead.png";